/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import { client, withUnwrap } from '../.kubb/client'
import type { MeReadEventOptions, MeReadEventResponses } from '../models/MeReadEvent'
import {
  meReadEventResponseSchema,
  meReadEventErrorSchema,
  meReadEventBodySchema,
} from '../schemas/meReadEventSchema'

/**
 * @summary User clicked an event: marks the whole GROUP read (info events only — hard actions clear only through
 * their data action) and, when the event belongs to another context, switches into it — same gate as
 * auth/switch (a role in the target org, an own internship, or an active EDU student link). On a switch a
 * fresh token pair is issued and the refresh cookie replaced, and the full user object comes back so the
 * client needs no follow-up call. When the switch is not allowed the read still happens and
 * `orgChanged` is false. In a SUPPORT (impersonation) session nothing is written and no switch
 * happens — the admin may look, the events stay unread. Not logged.
 * {@link /api/v4/me/readEvent}
 */
export function meReadEvent<ThrowOnError extends boolean = true>(
  options: Options<MeReadEventOptions, ThrowOnError>
): Unwrappable<RequestResult<MeReadEventResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/api/v4/me/readEvent',
      security: [{ type: 'http', scheme: 'bearer' }],
      validator: {
        request: meReadEventBodySchema,
        response: meReadEventResponseSchema,
        error: meReadEventErrorSchema,
      },
      contentType: { request: 'application/json-patch+json' },
      ...config,
    }) as Promise<RequestResult<MeReadEventResponses, ThrowOnError>>
  )
}
